import React, { useCallback, useEffect, useState } from 'react';
import {
  ApplicationType, MBSApplicationHeader, MBSApplicationHeaderProps,
  axiosInstance,
  useAuthStore,
  useConfigStore
} from "@fides/fides-react-components";
import { API_ENDPOINTS } from "../../constants/ApiEndpoints";
import { getPortalUser } from "../../api/helper";
import { PORTAL_DIRECTORY } from "../../constants/constant";
import { AppRoute } from "../../types/AppRoute";

const MBSHeader = () => {
  const isUserLoggedIn = useAuthStore(state => state.userIsLoggedIn);
  const user = useAuthStore(state => state.user);
  const portalUrl = useConfigStore.getState().portalUrl;

  const [appRoutes, setAppRoutes] = useState<Array<AppRoute> | null>(null);

  const getApplications = useCallback(() => {
    axiosInstance
      .request<any>({
        url: portalUrl + API_ENDPOINTS.fidesPortal.applications,
        method: 'POST',
      })
      .then((response) => setAppRoutes(response.data))
  }, [portalUrl]);

  // Do not display current application and if there is only one route (portal), filter it too!
  useEffect(() => {
    if (!!portalUrl && isUserLoggedIn) {
      getApplications();
    }
  }, [portalUrl, getApplications, isUserLoggedIn]);
  const applicationHeaderProps = {};

  const getFilterApps = (appRoutes: AppRoute[] | null) => {
    return appRoutes ? appRoutes.map((route) => route as ApplicationType) : [];
  }

  const navData = {
    portalUser: getPortalUser(user),
    applications: getFilterApps(appRoutes),
    language: user?.domainUser?.settings?.language || 'en',
  };

  const crumbsData= { crumbs: [], isDetailView: true, pageTitle: '' };

  const mbsApplicationHeaderProps: MBSApplicationHeaderProps['mbsApplicationHeaderProps'] = {
    ...navData,
    ...crumbsData,
    portalDirectory: PORTAL_DIRECTORY,
  };

  return (
      <MBSApplicationHeader
        mbsApplicationHeaderProps={mbsApplicationHeaderProps}
        applicationHeaderProps={applicationHeaderProps}
      />
  );
};

export default MBSHeader;